import { baseApi } from '@/lib/api/baseApi';
import { backToBackAccountsEndpoints } from './backToBackAccounts.queries';

export const backToBackAccountsApi = baseApi.injectEndpoints({
  endpoints: backToBackAccountsEndpoints,
});

export const {
  useGetBackToBackAccountsQuery,
  useLazyGenerateBackToBackAccountIdQuery,
  useCreateBackToBackAccountMutation,
  useUpdateBackToBackAccountMutation,
} = backToBackAccountsApi;
